import { gql } from "@apollo/client";

export const EDIT_PLANCUIDADO_STATE = gql`
    mutation ChangeStatusPlanCuidado(        
        $planCuidadoId: Int!
        $status: Boolean!
         ){
        changeStatusPlanCuidado(
            planCuidadoId : $planCuidadoId,
            status : $status
        ) {
            idPlanCuidado
        }
    }
`;